export default "__VITE_ASSET__Bg6UIDdA__"